import { howlMapper } from 'config/constants/audio'
import { InhouseGameDetails } from 'config/types/game'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import colors from 'theme/ui/colors'
import Box from 'UIKit/Box/Box'
import { StyledInhouseGameContainer } from '../components/styled'
import { GameInHouseConfig, InhouseGameBetBoardTab } from '../config/types'
import { useInhouseSession } from '../Plinko/hooks'
import MineBetSettings from './components/BetBoard'
import GameBoard from './components/GameBoard'
import { MINES_DEFAULT, MINE_GAME_SIZE } from './config'
import { useInitMineGameBet } from './hooks'

const MineGame: React.FC<GameInHouseConfig & { game: InhouseGameDetails }> = ({ volumeEnable, game, ...config }) => {
  const [mines, setMines] = useState(MINES_DEFAULT)
  const [tab, setTab] = useState(InhouseGameBetBoardTab.Manual)
  const [selectedBlocks, setSelectedBlocks] = useState([0])
  const [isLocked, setIsLocked] = useState(false)

  const { clearSession, initBet } = useInitMineGameBet()

  const loaderRef = useRef<HTMLDivElement>(null)
  const { isLoading, isLaunched, isClear, sessionId, bet, gameSettings } = useInhouseSession({ game })

  useEffect(() => {
    if (!isLoading) {
      loaderRef.current.style.opacity = '0'
      loaderRef.current.style.width = '0%'
      return
    }
    loaderRef.current.style.opacity = '1'
    loaderRef.current.style.width = '0%'

    const timeout1 = setTimeout(() => {
      loaderRef.current.style.width = '100%'
    }, 10)

    return () => {
      clearTimeout(timeout1)
    }
  }, [isLoading])

  useEffect(() => {
    // Init audio
    // eslint-disable-next-line no-unused-expressions
    howlMapper.MineDiamond
    // eslint-disable-next-line no-unused-expressions
    howlMapper.MineEffect
    // eslint-disable-next-line no-unused-expressions
    howlMapper.MineWin
    // eslint-disable-next-line no-unused-expressions
    howlMapper.MineBlockSelect
  }, [])

  useEffect(() => {
    if (MINE_GAME_SIZE * MINE_GAME_SIZE - mines < selectedBlocks.length) {
      setSelectedBlocks([])
    }
  }, [mines])

  useEffect(() => {
    if (bet?.id && sessionId && isLaunched && !isLoading) {
      setTab(InhouseGameBetBoardTab.Manual)
      initBet(bet)
    }
  }, [isLoading, isLaunched, sessionId, bet])

  useEffect(() => {
    if (isClear) {
      clearSession()
    }
  }, [isClear])

  return (
    <StyledInhouseGameContainer>
      <StyledProcessLoader
        ref={loaderRef}
        left="0px"
        height="2px"
        background={colors.primary}
        position="absolute"
        zIndex={2}
        top="0px"
      />
      {!isLoading && (
        <>
          <MineBetSettings
            isLocked={isLocked}
            setIsLocked={setIsLocked}
            tab={tab}
            setTab={setTab}
            volumeEnable={volumeEnable}
            mines={mines}
            setMines={setMines}
            {...config}
            width="100%"
            game={game}
            gameSettings={gameSettings}
            selectedBlocks={selectedBlocks}
            mt={['16px', '', '', '', '0']}
          />
          <GameBoard
            disabled={isLocked}
            volumeEnable={volumeEnable}
            game={game}
            mines={mines}
            autoMode={tab === InhouseGameBetBoardTab.Auto}
            selectedBlocks={selectedBlocks}
            setSelectedBlocks={setSelectedBlocks}
          />
        </>
      )}
    </StyledInhouseGameContainer>
  )
}

const StyledProcessLoader = styled(Box)`
  transition: 0.5s;
  width: 0%;
  pointer-events: none;
`

const MineGameMemorized = React.memo(MineGame)

export default MineGameMemorized
